/**
 * @description Pinia 持久化插件配置
 */
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { getRuntimeAuthKeys } from '~/composables/useStorageKey'
import { getAuthCookieOptions } from '~/utils/storageKey'
import { useUserStore } from '~/store/common/user'

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.server || !import.meta.client) {
    return
  }

  nuxtApp.$pinia.use(
    createPersistedState({
      storage:
        typeof localStorage !== 'undefined'
          ? localStorage
          : {
              getItem: () => null,
              setItem: () => {},
              removeItem: () => {},
            },
      debug: import.meta.dev,
    })
  )

  try {
    const userStore = useUserStore()
    const keys = getRuntimeAuthKeys()

    if (!userStore.accessToken && typeof localStorage !== 'undefined') {
      const persistedState = localStorage.getItem(keys.userPersistKey)
      if (persistedState) {
        try {
          const parsed = JSON.parse(persistedState)
          if (parsed.accessToken) {
            userStore.accessToken = parsed.accessToken
            userStore.refreshToken = parsed.refreshToken || null
            userStore.tokenExpiresAt = parsed.tokenExpiresAt || null
            userStore.refreshTokenExpiresAt = parsed.refreshTokenExpiresAt || null
            userStore.tokenRefreshNotBefore = Number(parsed.tokenRefreshNotBefore) || 0
            userStore.tokenRefreshNoProgressCount = Number(parsed.tokenRefreshNoProgressCount) || 0
            userStore.isLoggedIn = parsed.isLoggedIn || false
            if (parsed.userInfo) {
              userStore.userInfo = parsed.userInfo
            }
          }
        } catch (e) {
          // ignore
        }
      }
    }

    const tokenCookie = useCookie(keys.accessTokenCookie, getAuthCookieOptions())
    if (userStore.accessToken && tokenCookie.value !== userStore.accessToken) {
      tokenCookie.value = userStore.accessToken
    }
  } catch (e) {
    // ignore
  }
})
